import { EMPTY_STRING } from "./general.constant";

//-------Export System Constants
export const systemConstants = {
  LABEL_IMAGE_WIDTH: 85,
  REDUX_TRACE_LIMIT: 25,
  POS_ID: "CollectPOS",
  MIN_REGISTER_BALANCE: -1,
  LABEL_IMAGE_MAX_WIDTH: 150,
  MAX_NOTIFICATION_NUMBER: 99,
  TOGGLE_MODAL: "TOGGLE_MODAL",
  TOGGLE_SIDEBAR: "TOGGLE_SIDEBAR",
  SPINNER_ACTIVATE: "SPINNER_ACTIVATE",
  SET_SYSTEM_MODAL: "SET_SYSTEM_MODAL",
  SPINNER_DEACTIVATE: "SPINNER_DIACTIVATE",
  TOGGLE_REDIRECT_PAGE: "TOGGLE_REDIRECT_PAGE",
  TOGGLE_NESTED_SIDEBAR: "TOGGLE_NESTED_SIDEBAR",
  SET_ACTIVE_SIDEBAR_BTN: "SET_ACTIVE_SIDEBAR_BTN",
  SET_IS_SERVER_SEARCH_LOADING: "SET_IS_SERVER_SEARCH_LOADING",
  SET_ACTIVE_NESTED_SIDEBAR_BTN: "SET_ACTIVE_NESTED_SIDEBAR_BTN",
  DRAGGABLE_NOTIFICATION_ACTIVATE: "DRAGGABLE_NOTIFICATION_ACTIVATE",
  USER_PREFERENCES_DEBOUNCE: 2000, // i.e. column resizing save in db
  DRAGGABLE_NOTIFICATION_DEACTIVATE: "DRAGGABLE_NOTIFICATION_DEACTIVATE",
};

export const toastType = {
  INFO: "info",
  ERROR: "error",
  SUCCESS: "success",
  WARNING: "warning",
};

export const toastMessages = {
  ID_IS_EXPIRED: "ID is expired.",
  CHANGES_SAVED: "Changes saved.",
  NETWORK_ERROR: "Network error",
  ITEM_NOT_FOUND: "Item not found",
  NO_RECORD_FOUND: "No record found",
  NO_DEVICE_FOUND: "No device found",
  DEVICE_CONNECTED: "Device is connected",
  POIID_REQUIRED: "Poi Id is required",
  TAG_ALREADY_FOUND: "Tag already added!",
  ID_NOT_RECOGNIZED: "ID Not Recognized.",
  REQUEST_NOT_FOUND: "Request not found",
  REGISTER_IS_CLOSED: "Register is closed",
  VENDOR_IS_REQUIRED: "Vendor is Required",
  DELETED_SUCCESSFULLY: "Deleted successfully",
  INVOICE_ID_REQUIRED: "Invoice ID is required",
  CATEGORY_IS_REQUIRED: "Category is required.",
  UPDATED_SUCCESSFULLY: "Updated successfully.",
  SOMETHING_WENT_WRONG: "Something went wrong.",
  STORE_LOGO_NOT_FOUND: "Store Logo Not Found",
  ONLY_CSV_ALLOWED: "Only CSV file is Allowed",
  MAC_ADDRESS_NOT_FOUND:
    "Mac Address Not Found, Outlet may not work as expected.",
  INVENTORY_NOT_FOUND: "Inventory not found",
  PROBLEM_MESSAGE_SENT: "Submitted successfully",
  INVENTORY_INVALID_ERROR: "Quantity Cannot be 0",
  TOTAL_COST: "Total cost must be greater than 0",
  INVALID_TRANSACTION_ID: "Invalid Transaction Id",
  DELETE_USER_CONFIRMATION: "Delete User Account?",
  PLEASE_SELECT_CUSTOMER: "Please Select Customer",
  VALID_MOBILE: "Please enter a valid Phone Number",
  INVOICE_DATE_REQUIRED: "Invoice Date is required",
  VALID_EMAIL: "Please enter a valid Email Address",
  PRODUCT_ALREADY_ADDED: "Product is already added",
  SALE_TAX_UPDATED: "Current sale tax rate updated",
  CASH_ADDED_SUCCESSFULLY: "Cash Added Successfully",
  PLEASE_SELECT_A_CUSTOMER: "Please select customer",
  NO_PRINTER_DEVICE_FOUND: "No Printer Device Found",
  TYPE_ADDED_SUCCESSFULLY: "Type added successfully",
  TRANSFERED_SUCCESSFULLY: "Transferred Successfully",
  MISSING_REQUIRE_FIELD: "Require feilds are missing.",
  OUTLET_IS_NOT_CONFIGURED: "Outlet is not configured",
  SERIAL_NUMBER_REQUIRED: "Serial Number is required",
  PIN_UPDATED_SUCCESSFULLY: "Pin Updated Successfully",
  DRAFT_SAVED_SUCCESSFULLY: "Draft saved successfully",
  ADMIN_ADDED_SUCCESSFULLY: "Admin added successfully",
  PLEASE_SELECT_PRINTER: "Please select printer first",
  PLEASE_SELECT_CATEGORIES: "Please select categories",
  PLEASE_SELECT_PRODUCTS: "Please select products",
  CASH_REMOVED_SUCCESSFULLY: "Cash Removed Successfully",
  OUTLET_ADDED_SUCCESSFULLY: "Outlet added successfully",
  RECEIPT_SENT_SUCCESSFULLY: "Receipt sent successfully",
  STORE_ADDED_SUCCESSFULLY: "Store added successfully.",
  RESET_CART_WARNING: "Are you sure you want to reset?",
  ITEM_DELETED_SUCCESSFULLY: "Item Deleted Successfully",
  TYPE_UPDATED_SUCCESSFULLY: "Type updated successfully",
  TYPE_DELETED_SUCCESSFULLY: "Type deleted successfully",
  DEVICE_ADDED_SUCCESSFULLY: "Device Added Successfully",
  PLEASE_SELECT_ALL_OPTIONS: "Please select all options",
  PLEASE_SELECT_DEVICE: "Please select device to proceed",
  CLEAR_BATCH_WARNING: "Delete all items from the batch?",
  GLOBAL_MARGIN_ADDED: "Global margin added successfully",
  PLEASE_SELECT_LABEL_DESIGN: "Please Select Label Design",
  ADMIN_UPDATED_SUCCESSFULLY: "Admin updated successfully",
  ADMIN_DELETED_SUCCESSFULLY: "Admin deleted successfully",
  COMPANY_ADDED_SUCCESSFULLY: "Company added successfully",
  PLEASE_SELECT_SOME_PRODUCT: "Please select some product",
  DRAFT_DELETED_SUCCESSFULLY: "Draft deleted successfully",
  PORDUCT_ADDED_SUCCESSFULLY: "Product Added Successfully",
  INVENTORY_FILE_NOT_IMPORTED: " Items were not imported.",
  MONTHLY_BUDGET_ADDED: "Monthly Budget Saved Successfully",
  STORE_DELETED_SUCCESSFULLY: "Store deleted successfully.",
  STORE_UPDATED_SUCCESSFULLY: "Store updated successfully.",
  CATEGORY_ADDED_SUCCESSFULLY: "Category added successfully",
  EMPLOYEE_ADDED_SUCCESSFULLY: "Employee added successfully",
  CUSTOMER_ADDED_SUCCESSFULLY: "Customer added successfully",
  PORDUCTS_ADDED_SUCCESSFULLY: "Products Added Successfully",
  SESSION_CLOSED_SUCCESSFULLY: "Session closed successfully",
  DEVICE_DELETED_SUCCESSFULLY: "Device deleted Successfully",
  DEVICE_UPDATED_SUCCESSFULLY: "Device updated Successfully",
  CATEGORY_MARGIN_ADDED: "Category margin added successfully",
  TOTAL_CASH_OFFER: "Total cash offer must be greater than 0",
  RETURN_HAS_BEEN_SUCCESSFULL: " Return has been Successful",
  GLOBAL_MARKUP_UPDATED: "Global Markup updated successfully",
  BARCODE_DOESNOT_EXIST: "Barcode doesn’t exist in Inventory",
  SHARINK_UPDATED_SUCCESSFULLY: "Shrink updated Successfully",
  SESSION_STARTED_SUCCESSFULLY: "Session started successfully",
  INVOICE_DELETED_SUCCESSFULLY: "Invoice deleted successfully",
  REGISTER_CLOSED_SUCCESSFULLY: "Register closed successfully",
  REGISTER_OPENED_SUCCESSFULLY: "Register opened successfully",
  COMPANY_UPDATED_SUCCESSFULLY: "Company updated successfully",
  TRANSACTION_DRAFT_SUCCESSFULLY: "Transaction Added To Draft",
  COMPANY_DELETED_SUCCESSFULLY: "Company deleted successfully",
  PRODUCT_PRICES_UPDATED: "Product prices updated successfully",
  TOTAL_TRADE_OFFER: "Total trade offer must be greater than 0",
  CANNOT_BE_EXPORT_ARRAY_EMPTY: "Cannot download an empty CSV.",
  PARK_TRADE_SUCCESSFULLY: "Trade data has been saved to draft",
  PASSWORD_UPDATED_SUCCESSFULLY: "Password updated successfully",
  CUSTOMER_DELETED_SUCCESSFULLY: "Customer deleted successfully",
  CUSTOMER_UPDATED_SUCCESSFULLY: "Customer updated successfully",
  CATEGORY_UPDATED_SUCCESSFULLY: "Category updated successfully",
  EMPLOYEE_DELETED_SUCCESSFULLY: "Employee deleted successfully",
  EMPLOYEE_UPDATED_SUCCESSFULLY: "Employee updated successfully",
  CATEGORY_DISCOUNT_ADDED: "Category discount added successfully",
  CUSTOM_SALE_KEYWORD_RESERVED: "Custom sale Category is reserved",
  INVENTORY_UPDATED_SUCCESSFULLY: "Inventory updated Successfully",
  STORE_PURCHASING_POWER_UPDATED: "Store purchasing power updated",
  PRODUCT_DISMISSED_SUCCESSFULLY: "Product dismissed successfully",
  MARKUP_UPDATE_SUCCESSFULLY: "Custom Markup updated successfully",
  CSV_DUPLICATES_SKUS_NOT_ALLOWED: "Duplicate skus are not allowed",
  THRESHOLD_UPDATED_SUCCESSFULLY: "Threshold updated successfully.",
  MARKUP_DELETED_SUCCESSFULLY: "Csutom Markup deleted successfully",
  LOGO_SIZE_ERROR: "Logo width must be less than or equal to 256px.",
  SUB_CATEGORY_ADDED_SUCCESSFULLY: "Sub-Category added successfully",
  TRADE_PAGE_LEAVE_MESSAGE: "Do you want to Park the current trade ?",
  IMAGE_SIZE_ERROR: "Image width must be less than or equal to 256px.",
  INVENTORY_ITEMS_REQUIRED: "At least one inventory item is required.",
  VALID_CUSTOMER_REQUIRED: "Valid Customer Identification is required.",
  TRANSACTION_CANCEL_SUCCESSFULLY: "Transaction Cancelled Successfully",
  CYBERSOURCE_PAYMENT_CANCELLED_SUCCESSFULLY: "Payment cancelled successfully.",
  TRANSACTION_ADDED_SUCCESSFULLY: "Transaction Completed Successfully",
  CART_ITEM_DELETE_ERROR: "Sale total cannot be less than paid amount",
  DISCOUNT_CANNOT_EXCEED_SUBTOTAL:
    "Discount cannot be greater than the cart subtotal.",
  CANNOT_UPDATE_CART_DISCOUNT_EXCEEDS_SUBTOTAL:
    "Cannot update cart. Discount is greater than the subtotal. Reduce or remove the discount first.",
  INVALID_TRANSACTION_TOTAL:
    "Total amount is invalid. Please adjust the discount or cart before continuing.",
  SET_DEFAULT_PRINTER_SUCCESSFULLY: "Set default printer successfully",
  PLEASE_SET_DEFAULT_ZEBRA_PRINTER: "Please set default zebra printer",
  CUSTOM_CATEGORY_DELETED_SUCCESSFULLY: "Category deleted succesfully",
  SUB_CATEGORY_UPDATED_SUCCESSFULLY: "Sub-Category updated successfully",
  SUB_CATEGORY_DELETED_SUCCESSFULLY: "Sub-Category deleted successfully",
  SUCCESSFULLY_ADD_NEW_PRINTER: "Successfully added new receipt printer.",
  PLEASE_SET_DEFAULT_RECEIPT_PRINTER: "Please set default receipt printer",
  PRODUCT_ALREADY_FOUND_IN_INVENTORY: "Product already found in inventory",
  INVENTORY_FILE_IMPORTED_SUCCESSFULLY: " Items were successfully imported.",
  ALL_ITEMS_LOCKED_ERROR: "All items are locked. No changes can be applied.",
  AMOUNT_TO_PAY_LESS: `Enter an "Amount to Pay" value less than Total Amount`,
  CATEGORY_UPDATE_SUCCESSFULLY: "Custom Trade-In Margin updated Successfully",
  NO_INTERNET_ERROR: "You are offline. Please check your internet connection.",
  CASH_GREATER_THAN_TRADE: "Cash margin should be greater than trade margin.",
  CATEGORY_DELETED_SUCCESSFULLY: "Custom Trade-In Margin deleted successfully",
  SYSTEM_QUANTITY_MUST_BE_1: "Quantity of System with serial number must be 1",
  RECEIPT_DETAILS_UPDATED_SUCCESSFULLY: "Receipt details updated successfully.",
  SAME_PRODUCT_TYPE_REQUIRED:
    "Selected products must have the same product type.",
  AMOUNT_TO_PAY_GREATER: `Enter an "Amount to Pay" value greater than 0 to proceed`,
  CASH_TRADE_OFFER_MIN_VALUE:
    "Cash and Trade offer value must be greater than 0.",
  SERIAL_NUMBER_REQUIRED_BATCH:
    "Serial Number is missing for one or more items.",
  INVENTORY_UPDATED_AND_CATEGORY_COMPLETED:
    "Category Audit marked as Completed.",
  ADD_VENDOR_ERROR:
    "To add a new vendor, type the vendor name and click 'Add Vendor'.",
  GIFT_CARD_CANNOT_BE_RETURNED:
    "This gift card has been partially used and therefore cannot be refunded.",
  AMOUNT_TO_PAY_EQUALGREATER: `Enter an "Amount to Pay" value equal or greater than 0 to proceed`,
  INVENTORY_FILE_IMPORT:
    "File is imported and items are adding, we will update you in the notification about the errors.",
  SHOPIFY_TRANSACTION_CANNOT_BE_RETURNED:
    "Shopify transactions cannot be returned.",
  MIN_REGISTER_BALANCE_ERROR:
    "Starting Balance should be greater than or equal to 0",
  REGISTER_IS_CLOSED_IN_OTHER_TAB:
    "Register was closed on a different tab/window. The transaction has been saved as a draft.",
  PASSWORD_RESET_LINK_SENT_SUCCESSFULLY:
    "A password reset link has been successfully sent to your email.",
  VALUE_LESS_THAN_LOCKED_ITEMS:
    "Offer value cannot be less than or equal to the total cash offer or trade of locked items.",
  CUSTOM_MARKUP_ADDED_SUCCESSFULLY: "Custom Markup Added successfully",
  PRODUCT_SERIAL_NUMBER_SHOULD_BE_UNIQUE: "Serial Number must be unique.",
  UPDATE_CUSTOMER_ERROR:
    "Cannot remove current Customer because Store Credit payment was applied. Please contact the correct Customer if you need to refund this transaction and repeat it with the correct Customer selected.",
  CUSTOM_TRADE_IN_MARGIN_ADDED_SUCCESSFULLY:
    "Custom Trade-In Margin Added successfully",
  NOT_AUTHORIZED_TO_PERFORM_ACTION:
    "You are unauthorized to perform this action",
  CLEAR_PARTIAL_PAYMENT:
    "You must clear all Partial Payments before returning to the previous screen",
  INTERNAL_SERVER_ERROR: "Internal server error. Please report it.",
  PLEASE_CONTACT_AADMINISTRATOR: "Unexpected error. Please report it.",
  USER_INFORMATION_UPDATED_SUCCESSFULLY:
    "User information updated successfully",
  DUPLICATE_EMAIL_RECORDS:
    "File cannot be imported because of duplicate records, Email must be unique",
  DUPLICATE_NUMBER_RECORDS:
    "File cannot be imported because of duplicate records, Number must be unique",
  MAX_GREATER_THAN_MIN:
    "Min price should be less than max price. Please correct the prices.",
  START_DATE_MUST_BE_LESS_THAN_END_DATE:
    "Start Date must be less than end date",
  END_DATE_MUST_BE_GREATER_THAN_START_DATE:
    "End Date must be greater than start date",
  CATEGORY_DISCOUNT_DELETED_SUCCESSFULLY:
    "Category discount deleted successfully",
  CATEGORY_DISCOUNT_UPDATE_SUCCESSFULLY:
    "Category discount updated successfully",
  TRANSACTION_PAGE_LEAVE_MESSAGE:
    "Do you want to Park the current transaction ?",
  ADD_BATCH_INVENTORY_OR_TRADE_LEAVE_MESSAGE: "Save Batch?",
  ACTIVE_AUDIT_SESSION_PRESENT:
    "You will have to Complete or Cancel the currently active Audit Session before being able to start a new one.",
  UPDATE_SUCCESSFULLY: "Updated successfully.",
};

export const toolTipMessages = {
  STOCK_AUDIT_ITEMS: "Items = Unique Products/SKUs",
};

export const sessionStorageConstants = {
  STORE_INDEX: "STORE_INDEX",
};

export const categoryDropdownConstants = {
  BOX_ICON: "BOX_ICON",
  BEND_ICON: "BEND_ICON",
  CLOCK_ICON: "CLOCK_ICON",
  SEARCH_ICON: "SEARCH_ICON",
  DEFAULT_ICON: "DEFAULT_ICON",
  POS_DEVICE_ICON: "POS_DEVICE_ICON",
  TRANSACTION_ICON: "TRANSACTION_ICON",
  INVENTORY_LIST_ICON: "INVENTORY_LIST_ICON",
  NO_ICON: "NO_ICON",
};

export const ROLES = {
  ADMIN: "admin",
  COMPANY: "company",
  EMPLOYEE: "employee",
  STORE_OWNER: "store-owner",
  STORE_MANAGER: "store-manager",
};

export const skeletonArray = Array(20).fill({});

export const SYSTEM_MODAL_TYPES = {
  DELETE_USER_MODAL: "DELETE_USER_MODAL",
};

export const DEFAULT_SYSTEM_MODAL = {
  type: EMPTY_STRING,
  metaData: {},
};

export const SPINNER_TYPES = {
  TRADE_PROCESSING: "TRADE_PROCESSING",
  SALE_PROCESSING: "SALE_PROCESSING",
  IMPORT_INVENTORY: "IMPORT_INVENTORY",
  RETURN_PROCESSING: "RETURN_PROCESSING",
  INVOICE_PROCESSING: "INVOICE_PROCESSING",
  SHOPIFY_RESET_IN_PROGRESS: "SHOPIFY_RESET_IN_PROGRESS",
  PROCESSING: "PROCESSING",
  UPLOAD_TO_BLOB: "UPLOAD_TO_BLOB",
};

export const SPINNER_MESSAGES = {
  INVENTORY_IMPORT: "Inventory Importing...",
  TRADE_PROCESSING: "Processing Trade...",
  SALE_PROCESSING: "Processing Sale...",
  RETURN_PROCESSING: "Processing Return...",
  INVOICE_PROCESSING: "Processing Invoice...",
  SHOPIFY_RESET_IN_PROGRESS:
    "Updating Inventory Presets to Default in Progress (some actions are being blocked until this completes).",
  TRADE_DRAFT: "Saving Trade Draft...",
  SALE_DRAFT: "Saving Sale Draft...",
  UPLOADING: "Uploading...",
  PROCESSING: "Processing...",
};
export const CYBERSOURCE_LOG_VENDOR = "CYBERSOURCE";

export const payrilliumActions = {
  SALE_INITIATED: "SALE_INITIATED",

  AUTH_SUCCESS: "AUTH_SUCCESS",
  AUTH_FAILED: "AUTH_FAILED",
  AUTH_MISSING_TRANSACTION_ID: "AUTH_MISSING_TRANSACTION_ID",

  CAPTURE_SUCCESS: "CAPTURE_SUCCESS",
  CAPTURE_FAILED: "CAPTURE_FAILED",
  CAPTURE_ERROR: "CAPTURE_ERROR",

  TRANSACTION_ABORTED: "TRANSACTION_ABORTED",
  AUTH_REVERSED: "AUTH_REVERSED",

  REFUND_INITIATED: "REFUND_INITIATED",
  REFUND_SUCCESS: "REFUND_SUCCESS",
  REFUND_FAILED: "REFUND_FAILED",
};

export const COL_NAMES = {
  CUSTOMER_ID: "Customer ID",
  FIRST_NAME: "First Name",
  LAST_NAME: "Last Name",
  EMAIL: "Email",
  PHONE_NUMBER: "Phone Number",
  ID_TYPE: "Id Type",
  ID_NUMBER: "Id Number",
  DATE_OF_BIRTH: "Date of Birth",
  EXPIRATION_DATE: "Expiration Date",
  STREET_1: "Street 1",
  STREET_2: "Street 2",
  CITY: "City",
  STATE: "State",
  ZIP: "Zip",
  NOTES: "Notes",
  CUSTOMER_CREDIT: "Customer Credit",
  REJECTION_REASON: "Rejection Reason",
};
